import React from 'react';
import LocalizedDfpAd from './localized-dfp-ad';

class DfpAdInitDataDecorator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageTargeting: props.initData.gptData.customTargetingParameters,
            adUnitPath: props.initData.gptData.adUnitPath
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            nextProps.initData &&
            nextProps.initData.gptData &&
            nextProps.initData.gptData.customTargetingParameters
        ) {
            this.setState({
                pageTargeting:
                    nextProps.initData.gptData.customTargetingParameters,
                adUnitPath: nextProps.initData.gptData.adUnitPath
            });
        }
    }

    render() {
        return <LocalizedDfpAd {...this.state} {...this.props} />;
    }
}
export default DfpAdInitDataDecorator;
